import { m } from 'framer-motion';
import React from 'react';

import MotionLazy from './MotionLazy';

const OPTIONS = {
  animate: { opacity: 1 },
  initial: { opacity: 0 },
  transition: { duration: 0.5 },
};
export interface MotionFadeInProps {
  children: React.ReactNode;
  className?: string;
  animated?: boolean;
}
const MotionFadeIn = ({
  animated = true,
  children,
  className,
}: MotionFadeInProps) => {
  const initial = React.useMemo(() => {
    return { opacity: animated ? 0 : 1 };
  }, [animated]);
  return (
    <MotionLazy>
      <m.div
        transition={OPTIONS.transition}
        animate={OPTIONS.animate}
        className={className}
        initial={initial}
      >
        {children}
      </m.div>
    </MotionLazy>
  );
};

export default MotionFadeIn;
